import { useForm } from '../../context/FormContext'
import RegionSelect from '../ui/RegionSelect'
import Select from '../ui/Select'
import FormField from '../ui/FormField'
import Alert from '../ui/Alert'
import ar from '../../locales/ar.json'

const t  = ar.step6
const ta = ar.app

export default function Step6_Verification() {
  const { state, updateField } = useForm()
  const { formData, errors } = state

  return (
    <div>
      <h2 className="section-title">
        <span className="bg-primary-700 text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">٦</span>
        {t.sectionTitle}
      </h2>

      {/* ─── Location ─── */}
      <div className="mb-6">
        <h3 className="text-base font-semibold text-stone-700 mb-3">{t.locationSection}</h3>
        <RegionSelect
          regionValue={formData.region}
          neighborhoodValue={formData.neighborhood}
          onRegionChange={(v) => { updateField('region', v); updateField('neighborhood', '') }}
          onNeighborhoodChange={(v) => updateField('neighborhood', v)}
          errors={{ region: errors.region, neighborhood: errors.neighborhood }}
        />
      </div>

      {/* ─── Verification consent ─── */}
      <div className="mb-6">
        <h3 className="text-base font-semibold text-stone-700 mb-3">{t.verificationSection}</h3>
        <Select
          id="allow_official_verification"
          label={t.allow_official_verification}
          value={formData.allow_official_verification}
          onChange={(v) => updateField('allow_official_verification', v)}
          options={[{ value: 'نعم', label: ta.yes }, { value: 'لا', label: ta.no }]}
          placeholder={ta.select}
        />
      </div>

      {/* ─── Declaration ─── */}
      <div className="mb-6 p-4 bg-primary-50 border border-primary-200 rounded-xl">
        <h3 className="text-base font-semibold text-primary-800 mb-3">{t.declarationSection}</h3>

        {/* Affiliation declaration checkbox */}
        <label className="flex items-start gap-3 cursor-pointer mb-4">
          <input
            id="affiliationDeclaration"
            type="checkbox"
            checked={formData.affiliationDeclaration}
            onChange={(e) => updateField('affiliationDeclaration', e.target.checked)}
            className="mt-1 w-5 h-5 text-primary-700 rounded border-stone-400 flex-shrink-0"
            aria-required="true"
            aria-describedby={errors.affiliationDeclaration ? 'decl-error' : undefined}
          />
          <span className="text-sm text-primary-900 leading-relaxed">
            {t.affiliationDeclaration_label}
          </span>
        </label>
        {errors.affiliationDeclaration && (
          <div id="decl-error" className="mb-3">
            <Alert type="error" message={errors.affiliationDeclaration} />
          </div>
        )}

        {/* Final signature */}
        <FormField id="final_signature" label={t.final_signature} required error={errors.final_signature}>
          <input
            id="final_signature"
            type="text"
            value={formData.final_signature}
            onChange={(e) => updateField('final_signature', e.target.value)}
            className="input-base"
            aria-required="true"
            dir="rtl"
            placeholder="الاسم الكامل بوضوح"
          />
        </FormField>

        {/* Date */}
        <FormField id="final_date" label={t.final_date} required error={errors.final_date}>
          <input
            id="final_date"
            type="date"
            value={formData.final_date}
            onChange={(e) => updateField('final_date', e.target.value)}
            className="input-base"
            aria-required="true"
            dir="ltr"
            style={{ textAlign: 'right' }}
            max={new Date().toISOString().split('T')[0]}
          />
        </FormField>
      </div>

      {/* Summary note */}
      <Alert
        type="info"
        message="بعد التقديم ستتلقى رقم حالة للمتابعة. يرجى الاحتفاظ به."
      />
    </div>
  )
}
